<script>
import axios from 'axios';
import Question from './Question';

export default {
  name: 'QuestionList',
  components: {
    Question,
  },
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
    privacyAuditId: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      questions: [],
      // categoryId: categoryId,
    };
  },
  created() {
    const self = this;

    this.localDisabled = this.disabled;

    axios.get(`/privacyAudit/${this.privacyAuditId}/question`, {
      params: { categoryId: this.categoryId },
    })
      .then((response) => {
        self.questions = response.data;
      })
      .catch(() => {
        console.log('error');
      });
  },
};
</script>

<template>
  <div>
    <v-container fluid grid-list-lg pt-2 pa-0>
      <div v-for="question in questions" :key="question.id">

        <v-layout row wrap>
          <v-flex md12>
            <!--{{question.text}}-->
            <Question
              :question="question"
              :privacy-audit-id="privacyAuditId"
              :disabled="localDisabled"
            />
          </v-flex>
        </v-layout>

      </div>
    </v-container>
  </div>
</template>
